import React, { FC, PropsWithChildren, useEffect } from 'react';
import { cx } from 'linaria';
import { card, horizontalContent, horizontalLink, link, verticalContent } from './styles';
import { useInView } from 'react-cool-inview';
import { useDispatch } from 'react-redux';
import { RELATED_SERVICE_ITEM_IN_VIEWPORT } from '../../ducks';

export const DATA_QA_SERVICE = 'service-link';

type Props = {
  className?: string;
  containerClassName?: string;
  href?: string;
  onClick?: () => void;
  vertical?: boolean;
  dataQA?: string;
  serviceId?: number;
} & PropsWithChildren;

export const OrientationContext = React.createContext(false);

export const ServiceCard: FC<Props> = ({
  children,
  href,
  onClick,
  className,
  vertical = false,
  dataQA,
  containerClassName,
  serviceId,
}) => {
  const { observe, inView } = useInView({ threshold: 0.5, unobserveOnEnter: true });
  const dispatch = useDispatch();

  useEffect(() => {
    if (inView && serviceId) {
      dispatch(RELATED_SERVICE_ITEM_IN_VIEWPORT(serviceId));
    }
  }, [dispatch, inView, serviceId]);
  return (
    <a
      ref={observe}
      data-qa={dataQA ? dataQA : DATA_QA_SERVICE}
      className={cx(link, !vertical ? horizontalLink : null, className)}
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      onClick={onClick}
    >
      <OrientationContext.Provider value={vertical}>
        <div className={cx(card, vertical ? verticalContent : horizontalContent, containerClassName)}>
          {children}
        </div>
      </OrientationContext.Provider>
    </a>
  );
};
